import { Button, Spinner } from "@instructure/ui";
import { t } from "i18next";
import { useState } from "react";
import { LearningOutcomesService } from "../../../../../services/LearningOutcomesService";
import {
  ERROR,
  useNotification,
} from "../../../../CustomHooks/NotificationProvider";

const RenderSubmitContent = ({
  row,
  setRows,
  cols,
  ratingToMasteryLevelMap,
  assignmentRubric,
  setAssignmentRubric,
  rebuildSubmitColumn,
}) => {
  const showNotification = useNotification();
  const [submitting, setSubmitting] = useState(false);

  const checkRubricCompletion = () => {
    let incompleteRubric = false;
    Object.entries(row.ratingLevels).forEach((ratingLevel) => {
      if (ratingLevel[1] === "") {
        incompleteRubric = true;
      }
    });
    return incompleteRubric;
  };

  const addUpdateParameters = (rubricData) => {
    const outcomeRatingScale = assignmentRubric.rating_scales.find(
      (rs) => rs.criteria_id === row.id
    );
    if (outcomeRatingScale) {
      rubricData.id = outcomeRatingScale.ddl_id;
      rubricData.levels.forEach((level) => {
        const rating = outcomeRatingScale.rating_levels.find(
          (r) => r.insights_rating_level === level.insights_rating_level
        );
        if (rating) {
          level.id = rating.ddl_id;
        }
      });
    }
    return rubricData;
  };

  const handleSubmitCriteria = (row) => {
    const incompleteRubric = checkRubricCompletion();
    if (incompleteRubric) {
      showNotification(t("assessment.incompleteRubric"), ERROR);
    } else {
      // Disables "Save/Update Criteria" to prevent multiple submissions at the same time,
      // which can cause issues when making an instantiating an assignment rubric for the first time.
      setRows((prevRows) => {
        let newRows = [...prevRows];
        newRows = newRows.map((prevRow) => ({ ...prevRow, disabled: true }));
        return newRows;
      });
      setSubmitting(true);
      // Create a payload for the assignment rubric
      const ratingLevels = [];
      Object.entries(row.ratingLevels).forEach(([levelId, description]) => {
        const rating = cols.find(
          (col) => col.insights_rating_level === levelId
        );
        const ratingScaleObj = {
          points: rating.score,
          description: description,
          insights_rating_level: rating.insights_rating_level,
        };
        ratingLevels.push(ratingScaleObj);
      });
      const criteriaId = row.id;
      let rubricData = {
        criteria_id: criteriaId,
        levels: ratingLevels,
        mastery_at: ratingToMasteryLevelMap.mastery_points,
      };
      if (assignmentRubric) {
        rubricData = addUpdateParameters(rubricData);
      }
      const rubricPayload = {
        rating_to_mastery_level_map: ratingToMasteryLevelMap,
        outcome_scale_map: rubricData,
      };
      if (assignmentRubric) {
        rubricPayload.assignment_rubric_id = assignmentRubric.ddl_id;
      }
      LearningOutcomesService.upsertAssignmentRubric(rubricPayload)
        .then((assignmentRubric) => {
          showNotification(t("ratingScale.criteriaSuccess"));
          setAssignmentRubric(assignmentRubric);
          rebuildSubmitColumn(cols, assignmentRubric);
          setRows((prevRows) => {
            let newRows = [...prevRows];
            newRows = newRows.map((prevRow) =>
              prevRow.id === row.id ? { ...prevRow, save: false } : prevRow
            );
            return newRows;
          });
        })
        .catch(() => {
          showNotification(t("ratingScale.criteriaError"), ERROR);
        })
        .finally(() => {
          setRows((prevRows) => {
            let newRows = [...prevRows];
            newRows = newRows.map((prevRow) => ({
              ...prevRow,
              disabled: false,
            }));
            return newRows;
          });
          setSubmitting(false);
        });
    }
  };

  return (
    row.id !== "raterRow" && (
      <div style={{ textAlign: "center" }}>
        <Button
          size="small"
          onClick={() => handleSubmitCriteria(row)}
          disabled={row.disabled}
        >
          {submitting ? (
            <Spinner renderTitle={t("global.pleaseWait")} size="x-small" />
          ) : row.save ? (
            t("ratingScale.saveCriteria")
          ) : (
            t("ratingScale.updateCriteria")
          )}
        </Button>
      </div>
    )
  );
};

export default RenderSubmitContent;
